import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Grid from '@mui/material/Grid';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { visuallyHidden } from '@mui/utils';

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import {string} from "prop-types";
import {jwtDecode} from "jwt-decode";
import Link from "@mui/material/Link";

import WarrantyPolicy from '../files/RCP RGA Warrany _ Return Goods Policy rev 3.pdf'
import Instructions from '../files/RCP RGA Manual.pdf'

function RGAForm() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [rcpPnValid, setRcpPnValid] = useState(false);
  const rcpPnValidError = "This field must be exactly 8 digits long.";
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const [emptyCustName, setEmptyCustName] = useState(false);
  const [emptyCustContactFirstName, setEmptyCustContactFirstName] = useState(false);
  const [emptyCustContactLastName, setEmptyCustContactLastName] = useState(false);
  const [emptyCustEmail, setEmptyCustEmail] = useState(false);
  const [emptyPhoneNum, setEmptyPhoneNum] = useState(false);
  const [emptyCustomerReturnName, setEmptyCustomerReturnName] = useState(false);
  const [emptyCustomerReturnAddress, setEmptyCustomerReturnAddress] = useState(false);
  const [emptyCustomerReturnCity, setEmptyCustomerReturnCity] = useState(false);
  // const [emptyCustomerReturnState, setEmptyCustomerReturnState] = useState(false);
  const [emptyCustomerReturnZip, setEmptyCustomerReturnZip] = useState(false);
  const [emptyCustomerReturnCountry, setEmptyCustomerReturnCountry] = useState(false);
  const [emptyDescription, setEmptyDescription] = useState(false);
  const [emptyDescriptionSnackbar, setEmptyDescriptionSnackbar] = useState(false);
  const emptyFieldError = "This field cannot be left empty.";

  const [emailRGACopyToCustomer, setEmailRGACopyToCustomer] = useState(true);

  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [multipleEntriesInvalid, setMultipleEntriesInvalid] = useState(false);
  const [hasMultipleEntries, setHasMultipleEntries] = useState(false);
  const [multipleConfirmed, setMultipleConfirmed] = useState(false);
  const [multipleEntriesCount, setMultipleEntriesCount] = useState(1);
  const [multEntriesSerialNumList, setMultEntriesSerialNumList] = useState(["rcpSerialNum1"]);
  const [multEntriesDefectCodesList, setMultEntriesDefectCodesList] = useState(["defectCodeNum1"]);
  const [multEntriesProdDateList, setMultEntriesProdDateList] = useState(["prodDate1"]);
  const [multEntriesServiceDateList, setMultEntriesServiceDateList] = useState(["inServiceDate1"]);
  const [multEntriesServiceHoursList, setMultEntriesServiceHoursList] = useState(["inServiceHours1"]);
  const [multEntriesDescList, setMultEntriesDescList] = useState(["description1"]);
  const [multipleEntriesList, setMultipleEntriesList] = useState([]);
      // useState([<Grid item xs={3} sm={3} md={3} lg={3} xl={3} key={0}>
      //                               <TextField margin="normal" name="rcpSerialNum1"
      //                                 label="RCP Serial Number" id="rcpSerialNum1" fullWidth/></Grid>,
      //                         <Grid item xs={3} sm={3} md={3} lg={3} xl={3} key={1}>
      //                             <LocalizationProvider dateAdapter={AdapterDayjs}>
      //                                 <DatePicker label="Production Date" name="prodDate1"
      //                                             slotProps={{ textField: { fullWidth: true } }}/>
      //                                 <DatePicker label="In Service Date" name="inServiceDate1"
      //                                             slotProps={{ textField: { fullWidth: true } }}/>
      //                             </LocalizationProvider></Grid>,
      //                         <Grid item xs={3} sm={3} md={3} lg={3} xl={3} key={2}>
      //                             <TextField
      //                                 margin="normal"
      //                                 name="inServiceHours1"
      //                                 label="In Service Hours"
      //                                 id="inServiceHours1"
      //                                 type="number"
      //                                 fullWidth
      //                             /></Grid>,
      //                       <Grid item xs={3} sm={3} md={3} lg={3} xl={3} key={3}>
      //                         <TextField
      //                             margin="normal"
      //                             name="description1"
      //                             label="Description of Failure"
      //                             id="description1"
      //                             multiline
      //                             rows={5}
      //                             required
      //                             fullWidth
      //                               /></Grid>]);

  const [rgaImages, setRgaImages] = useState([]);
  const [rgaImageFiles, setRgaImageFiles] = useState([]);

  const forceUpdate = React.useReducer(() => ({}))[1];

  const handleCopyRGAToCustomer = (event) => {
      setEmailRGACopyToCustomer(!emailRGACopyToCustomer);
  }

  const confirmChanges = (event) =>{
      if (multipleEntriesCount <= 0) {
          setMultipleEntriesInvalid(true);
      }
      else {
          setMultipleEntriesInvalid(false);
          setMultipleConfirmed(true);
          let tempSerialNumList = [];
          let tempDefectCodeList = [];
          let tempProdDateList = [];
          let tempServiceDateList = [];
          let tempServiceHoursList = [];
          let tempDescList = [];
          let tempList = [];
          let serial_id = "rcpSerialNum";
          let defect_code_id = "defectCodeNum";
          let prod_date_id = "prodDate";
          let in_serv_date_id = "inServiceDate";
          let in_serv_hours_id = "inServiceHours";
          let desc_id = "description";
          for (let i = 0; i < multipleEntriesCount; i++) {
              let new_serial_id = serial_id.concat(i.toString());
              let new_defect_code_id = defect_code_id.concat(i.toString());
              let new_prod_date_id = prod_date_id.concat(i.toString());
              let new_in_serv_date_id = in_serv_date_id.concat(i.toString());
              let new_in_serv_hours_id = in_serv_hours_id.concat(i.toString());
              let new_desc_id = desc_id.concat(i.toString());
              tempList.push(<Grid item xs={2.4} sm={2.4} md={2.4} lg={2.4} xl={2.4} key={i * 5}><TextField margin="normal"
                                                                                                 name={new_serial_id}
                                                                                                 label="RCP Serial Number"
                                                                                                 id={new_serial_id}
                                                                                                 fullWidth
                                                                                                 helperText="Leave blank if there is no serial number"/></Grid>);
              tempSerialNumList.push(new_serial_id)
              tempList.push(<Grid item xs={2.4} sm={2.4} md={2.4} lg={2.4} xl={2.4} key={(i * 5) + 1}><TextField margin="normal"
                                                                                                 name={new_defect_code_id}
                                                                                                 label="Customer Defect Code"
                                                                                                 id={new_defect_code_id}
                                                                                                 fullWidth
                                                                                                 helperText="Leave blank if you have no defect code"/></Grid>);
              tempDefectCodeList.push(new_defect_code_id)
              tempList.push(<Grid item xs={2.4} sm={2.4} md={2.4} lg={2.4} xl={2.4} key={(i * 5) + 2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker label="Production Date" name={new_prod_date_id}
                                  slotProps={{textField: {fullWidth: true}}}/>
                      <DatePicker label="In Service Date" name={new_in_serv_date_id}
                                  slotProps={{textField: {fullWidth: true}}}/>
                  </LocalizationProvider></Grid>);
              tempProdDateList.push(new_prod_date_id)
              tempServiceDateList.push(new_in_serv_date_id)
              tempList.push(<Grid item xs={2.4} sm={2.4} md={2.4} lg={2.4} xl={2.4} key={(i * 5) + 3}>
                  <TextField
                      margin="normal"
                      name={new_in_serv_hours_id}
                      label="In Service Hours"
                      id={new_in_serv_hours_id}
                      type="number"
                      fullWidth/></Grid>);
              tempServiceHoursList.push(new_in_serv_hours_id)
              tempList.push(<Grid item xs={2.4} sm={2.4} md={2.4} lg={2.4} xl={2.4} key={(i * 5) + 4}>
                  <TextField
                      margin="normal"
                      name={new_desc_id}
                      label="Description of Failure"
                      id={new_desc_id}
                      multiline
                      rows={5}
                      required
                      fullWidth
                      error={emptyDescription}
                      helperText={emptyDescription ? emptyFieldError : ""}/></Grid>);
              tempDescList.push(new_desc_id)
          }
          setMultipleEntriesList(tempList);
          setMultEntriesSerialNumList(tempSerialNumList);
          setMultEntriesDefectCodesList(tempDefectCodeList);
          setMultEntriesProdDateList(tempProdDateList);
          setMultEntriesServiceDateList(tempServiceDateList);
          setMultEntriesServiceHoursList(tempServiceHoursList);
          setMultEntriesDescList(tempDescList);
      }
  }

  const changeMultipleEntriesCount = (event) => {
      setMultipleEntriesCount(parseInt(event.target.value));
  }

  const showMultipleEntries = (event) => {
      setHasMultipleEntries(!hasMultipleEntries);
  }

  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccessSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  const handleEmptyDescriptionSnackbarClose = (event, reason) => {
   if (reason === 'clickaway') {
      return;
    }
    setEmptyDescriptionSnackbar(false);
  };

  const handleUpload = (event) => {
      let tempImgList = rgaImages;
      let tempFileList = rgaImageFiles;
      const reader = new FileReader();
      for (let i=0; i<event.target.files.length; i++){
          let file = event.target.files[i];
          tempFileList.push(file);
          let result = URL.createObjectURL(file);
          const image = new Image();
          image.title = file.name;
          image.src = result;
          tempImgList.push(image);
      }
      setRgaImages(tempImgList);
      setRgaImageFiles(tempFileList);
      // console.log(rgaImages);
      // console.log(rgaImageFiles);
      forceUpdate();
  }

  const handleSubmit = async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      let claimNum = "";
      const decoded = jwtDecode(user.token);
      const userInfo = decoded.id;
      const curr_email = userInfo[0];
      let descriptionEmpty = false;
      if (multipleConfirmed) {
          for (let i = 0; i < multipleEntriesCount; i++) {
              if (data.get(multEntriesDescList[i]).length === 0) {
                  descriptionEmpty = true;
                  break;
              }
          }
      }
      else {
          if (data.get('description').length === 0) {
              descriptionEmpty = true;
          }
      }
      if (data.get('custName').length === 0) {
          setEmptyCustName(true);
      }
      else if (data.get('custContactFirstName').length === 0) {
          setEmptyCustContactFirstName(true);
      }
      else if (data.get('custContactLastName').length === 0) {
          setEmptyCustContactLastName(true);
      }
      else if (data.get('custEmail').length === 0) {
          setEmptyCustEmail(true);
      }
      else if (data.get('phone_num').length === 0) {
          setEmptyPhoneNum(true);
      }
      else if (data.get('customerReturnName').length === 0) {
          setEmptyCustomerReturnName(true);
      }
      else if (data.get('customerReturnAddress').length === 0) {
          setEmptyCustomerReturnAddress(true);
      }
      else if (data.get('customerReturnCity').length === 0) {
          setEmptyCustomerReturnCity(true);
      }
      else if (data.get('customerReturnZip').length === 0) {
          setEmptyCustomerReturnZip(true);
      }
      else if (data.get('customerReturnCountry').length === 0) {
          setEmptyCustomerReturnCountry(true);
      }
      else if (data.get('rcpPN').length !== 8) {
          setRcpPnValid(true);
      }
      else if (descriptionEmpty) {
          if (multipleConfirmed) {
              setEmptyDescriptionSnackbar(true);
          }
          else {
              setEmptyDescription(true);
          }
      }
      else {
          setSubmitDisabled(true);
          setEmptyCustName(false);
          setEmptyCustContactFirstName(false);
          setEmptyCustContactLastName(false);
          setEmptyCustEmail(false);
          setEmptyPhoneNum(false);
          setEmptyCustomerReturnName(false);
          setEmptyCustomerReturnAddress(false);
          setEmptyCustomerReturnCity(false);
          setEmptyCustomerReturnZip(false);
          setEmptyCustomerReturnCountry(false);
          setRcpPnValid(false);
          setEmptyDescription(false);
          if (multipleConfirmed) {
              let serialNums = [];
              let defectCodes = [];
              let prodDates = [];
              let inServiceDates = [];
              let inServiceHours = [];
              let descriptions = [];
              for (let i = 0; i < multipleEntriesCount; i++) {
                  serialNums.push(data.get(multEntriesSerialNumList[i]));
                  defectCodes.push(data.get(multEntriesDefectCodesList[i]));
                  prodDates.push(data.get(multEntriesProdDateList[i]));
                  inServiceDates.push(data.get(multEntriesServiceDateList[i]));
                  inServiceHours.push(data.get(multEntriesServiceHoursList[i]));
                  descriptions.push(data.get(multEntriesDescList[i]));
              }
              // console.log({
              //     custName: data.get('custName'),
              //     custContactFirstName: data.get('custContactFirstName'),
              //     custContactLastName: data.get('custContactLastName'),
              //     email: curr_email,
              //     phone_num: data.get('phone_num'),
              //     rcpPN: data.get('rcpPN'),
              //     custPN: data.get('custPN'),
              //     purchOrderNumber: data.get('purchOrderNumber'),
              //     quantity: multipleEntriesCount,
              //     serialNumber: serialNums,
              //     prodDate: prodDates,
              //     inServiceDate: inServiceDates,
              //     inServiceHours: inServiceHours,
              //     description: descriptions,
              //     images: rgaImageFiles,
              // });
              await axios.post('/api/submitrga', {
                  custName: data.get('custName'),
                  custContactFirstName: data.get('custContactFirstName'),
                  custContactLastName: data.get('custContactLastName'),
                  custEmail: data.get('custEmail'),
                  custClaimNum: data.get('custClaimNum'),
                  user_email: curr_email,
                  phone_num: data.get('phone_num'),
                  rcpPN: data.get('rcpPN'),
                  custPN: data.get('custPN'),
                  custReturnCompName: data.get('customerReturnCompanyName'),
                  custReturnName: data.get('customerReturnName'),
                  custReturnAddress: data.get('customerReturnAddress'),
                  custReturnAddress2: data.get('customerReturnAddress2'),
                  custReturnCity: data.get('customerReturnCity'),
                  custReturnState: data.get('customerReturnState'),
                  custReturnZip: data.get('customerReturnZip'),
                  custReturnCountry: data.get('customerReturnCountry'),
                  purchOrderNumber: data.get('purchOrderNumber'),
                  quantity: multipleEntriesCount,
                  serialNumber: serialNums,
                  defectCode: defectCodes,
                  prodDate: prodDates,
                  inServiceDate: inServiceDates,
                  inServiceHours: inServiceHours,
                  description: descriptions,
                  emailRGACopyToCustomer: emailRGACopyToCustomer,
              }).then(function (response) {
                  // console.log(response);
                  claimNum = response.data.claimNum;
              })
              .catch(function (error) {
                  console.log(error);
                  setOpenErrorSnackbar(true);
              });
              const formData = new FormData();
              for (let i = 0; i < rgaImageFiles.length; i++) {
                  let frontStr = claimNum.concat("-")
                  let newName = frontStr.concat(rgaImageFiles[i].name)
                  formData.append('file', rgaImageFiles[i], newName);
              }
              axios.post('/api/submitrgaimages', formData
              ).then(function (response) {
                  // console.log(response);
                  // navigate(0);
                  setOpenSuccessSnackbar(true);
              })
              .catch(function (error) {
                  console.log(error);
                  // navigate(0);
                  setOpenErrorSnackbar(true);
              });

          } else {
              // console.log({
              //     custName: data.get('custName'),
              //     custContactFirstName: data.get('custContactFirstName'),
              //     custContactLastName: data.get('custContactLastName'),
              //     email: curr_email,
              //     phone_num: data.get('phone_num'),
              //     rcpPN: data.get('rcpPN'),
              //     custPN: data.get('custPN'),
              //     purchOrderNumber: data.get('purchOrderNumber'),
              //     quantity: "1",
              //     serialNumber: data.get('serialNumber'),
              //     prodDate: data.get('prodDate'),
              //     inServiceDate: data.get('inServiceDate'),
              //     inServiceHours: data.get('inServiceHours'),
              //     description: data.get('description'),
              // });
              await axios.post('/api/submitrga', {
                  custName: data.get('custName'),
                  custContactFirstName: data.get('custContactFirstName'),
                  custContactLastName: data.get('custContactLastName'),
                  custEmail: data.get('custEmail'),
                  custClaimNum: data.get('custClaimNum'),
                  user_email: curr_email,
                  phone_num: data.get('phone_num'),
                  rcpPN: data.get('rcpPN'),
                  custPN: data.get('custPN'),
                  custReturnCompName: data.get('customerReturnCompanyName'),
                  custReturnName: data.get('customerReturnName'),
                  custReturnAddress: data.get('customerReturnAddress'),
                  custReturnAddress2: data.get('customerReturnAddress2'),
                  custReturnCity: data.get('customerReturnCity'),
                  custReturnState: data.get('customerReturnState'),
                  custReturnZip: data.get('customerReturnZip'),
                  custReturnCountry: data.get('customerReturnCountry'),
                  purchOrderNumber: data.get('purchOrderNumber'),
                  quantity: "1",
                  serialNumber: [data.get('serialNumber')],
                  defectCode: [data.get('defectCode')],
                  prodDate: [data.get('prodDate')],
                  inServiceDate: [data.get('inServiceDate')],
                  inServiceHours: [data.get('inServiceHours')],
                  description: [data.get('description')],
                  emailRGACopyToCustomer: emailRGACopyToCustomer,
              }).then(function (response) {
                  // console.log(response);
                  if (response.status === 200) {
                      claimNum = response.data.claimNum;
                  }
              })
              .catch(function (error) {
                  console.log(error);
                  setOpenErrorSnackbar(true);
              });
              const formData = new FormData();
              for (let i = 0; i < rgaImageFiles.length; i++) {
                  let frontStr = claimNum.concat("-")
                  let newName = frontStr.concat(rgaImageFiles[i].name)
                  formData.append('file', rgaImageFiles[i], newName);
              }
              axios.post('/api/submitrgaimages', formData
              ).then(function (response) {
                  // console.log(response);
                  // navigate(0);
                  setOpenSuccessSnackbar(true);
              })
              .catch(function (error) {
                  console.log(error);
                  // navigate(0);
                  setOpenErrorSnackbar(true);
              });
          }
      }
  };

  return (
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
          <Stack spacing={3} direction='column' width='75%'>
              <Card>
                  <CardHeader title="Submission Instructions"></CardHeader>
                  <CardContent>
                      <Link href={Instructions} target="_blank" download="RCP RGA Manual.pdf">Instructions</Link>
                  </CardContent>
              </Card>
              <Card>
                  <CardContent>
                      <FormControlLabel control={<Checkbox checked={emailRGACopyToCustomer}
                                             onChange={handleCopyRGAToCustomer} color="primary"/>} label="Send an Email Copy of Claim Submission to Customer" />
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Company Information:">
                  </CardHeader>
                  <CardContent>
                      <Stack spacing={5} direction='column'>
                          <TextField
                              margin="normal"
                              required
                              id="custName"
                              label="Company Name"
                              name="custName"
                              error={emptyCustName}
                              helperText={emptyCustName ? emptyFieldError : ""}
                            />
                            <TextField
                              margin="normal"
                              required
                              name="custContactFirstName"
                              label="First Name"
                              id="custContactFirstName"
                              error={emptyCustContactFirstName}
                              helperText={emptyCustContactFirstName ? emptyFieldError : ""}
                            />
                              <TextField
                              margin="normal"
                              required
                              name="custContactLastName"
                              label="Last Name"
                              id="custContactLastName"
                              error={emptyCustContactLastName}
                              helperText={emptyCustContactLastName ? emptyFieldError : ""}
                            />
                              <TextField
                              margin="normal"
                              required
                              name="custEmail"
                              label="Email"
                              id="custEmail"
                              error={emptyCustEmail}
                              helperText={emptyCustEmail ? emptyFieldError : ""}
                            />
                              <TextField
                              margin="normal"
                              name="custClaimNum"
                              label="Company RGA Claim Number"
                              id="custClaimNum"
                            />
                          <TextField
                              margin="normal"
                              required
                              name="phone_num"
                              label="Phone Number"
                              id="phone_num"
                              error={emptyPhoneNum}
                              helperText={emptyPhoneNum ? emptyFieldError : ""}
                          />
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Return Shipping Information"></CardHeader>
                  <CardContent>
                      <Stack spacing={5} direction='column'>
                          <TextField
                          margin="normal"
                          name="customerReturnCompanyName"
                          label="Company Name"
                          id="customerReturnCompanyName"
                        />
                          <TextField
                          margin="normal"
                          required
                          name="customerReturnName"
                          label="Full Name"
                          id="customerReturnName"
                          error={emptyCustomerReturnName}
                          helperText={emptyCustomerReturnName ? emptyFieldError : ""}
                        />
                          <TextField
                          margin="normal"
                          required
                          name="customerReturnAddress"
                          label="Address"
                          id="customerReturnAddress"
                          error={emptyCustomerReturnAddress}
                          helperText={emptyCustomerReturnAddress ? emptyFieldError : ""}
                        />
                          <TextField
                          margin="normal"
                          name="customerReturnAddress2"
                          label="Address 2"
                          id="customerReturnAddress2"
                        />
                          <TextField
                          margin="normal"
                          required
                          name="customerReturnCity"
                          label="City"
                          id="customerReturnCity"
                          error={emptyCustomerReturnCity}
                          helperText={emptyCustomerReturnCity ? emptyFieldError : ""}
                        />
                          <TextField
                          margin="normal"
                          name="customerReturnState"
                          label="State / Province"
                          id="customerReturnState"
                        />
                          <TextField
                          margin="normal"
                          required
                          name="customerReturnZip"
                          label="Zip"
                          id="customerReturnZip"
                          error={emptyCustomerReturnZip}
                          helperText={emptyCustomerReturnZip ? emptyFieldError : ""}
                        />
                          <TextField
                          margin="normal"
                          required
                          name="customerReturnCountry"
                          label="Country"
                          id="customerReturnCountry"
                          error={emptyCustomerReturnCountry}
                          helperText={emptyCustomerReturnCountry ? emptyFieldError : ""}
                        />
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Product Information:">
                  </CardHeader>
                  <CardContent>
                      <Stack spacing={5} direction='column'>
                          <TextField
                          margin="normal"
                          required
                          name="rcpPN"
                          label="RCP Part Number"
                          id="rcpPN"
                          error={rcpPnValid}
                          helperText={rcpPnValid ? rcpPnValidError : ""}
                        />
                          <TextField
                          margin="normal"
                          name="custPN"
                          label="Customer Part Number"
                          id="custPN"
                        />
                          <TextField
                          margin="normal"
                          name="purchOrderNumber"
                          label="Purchase Order Number"
                          id="purchOrderNumber"
                        />
                      <FormControlLabel
                          control={<Checkbox checked={hasMultipleEntries} disabled={multipleConfirmed}
                                             onChange={showMultipleEntries} color="primary" />}
                          label="Multiple Serial Numbers of the Same Part"
                        />
                          { hasMultipleEntries ?
                              <Stack direction="column" spacing={3}>
                                  <p>Please choose a quantity and press "Confirm" before entering the
                                      information below.</p>
                                  <Stack direction="row" spacing={2}>
                                      <TextField
                                          margin="normal"
                                          name="quantity"
                                          label="Quantity"
                                          id="quantity"
                                          type="number"
                                          required
                                          disabled={multipleConfirmed}
                                          defaultValue={1}
                                          onChange={changeMultipleEntriesCount}
                                          error={multipleEntriesInvalid}
                                          helperText={multipleEntriesInvalid ? "Value must be set and greater than 0." : ""}
                                          />
                                      <Button
                                          variant="contained"
                                          disabled={multipleConfirmed}
                                          onClick={confirmChanges}
                                          sx={{ mt: 3, mb: 2 }}>
                                          Confirm
                                      </Button>
                                  </Stack>
                              </Stack>
                              :''}
                          { hasMultipleEntries ?
                              <Grid container direction="row" alignContent="center" alignItems="center" spacing={1}>
                                  {multipleEntriesList.length > 0 && multipleEntriesList.map(
                                      (text_item) => text_item)}</Grid>:
                              <Stack direction="column" spacing={2}>
                                  <TextField margin="normal" name="serialNumber"
                               label="RCP Serial Number" id="rcpSerialNum" helperText="Leave blank if there is no serial number"/>
                                  <TextField margin="normal" name="defectCode" label="Customer Defect Code"
                                             id="defectCodeNum" helperText="Leave blank if you have no defect code"/>
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DatePicker label="Production Date" name="prodDate"/>
                                      <DatePicker label="In Service Date" name="inServiceDate"/>
                                  </LocalizationProvider>
                              <TextField
                                  margin="normal"
                                  name="inServiceHours"
                                  label="In Service Hours"
                                  id="inServiceHours"
                                  type="number"
                                  />
                              <TextField
                                  margin="normal"
                                  name="description"
                                  label="Description of Failure"
                                  id="description"
                                  multiline
                                  rows={5}
                                  required
                                  error={emptyDescription}
                                  helperText={emptyDescription ? emptyFieldError : ""}
                                    />
                              </Stack>}
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Photos (limit 20):">
                  </CardHeader>
                  <CardContent>
                      <Box>Allowed Formats: JPG, JPEG, PNG</Box>
                      <Button component="label" variant="contained" onChange={handleUpload}>
                          Upload Image(s)
                          <TextField type="file" sx={ visuallyHidden }/>
                        </Button>
                      <ImageList sx={{ width: 1250, height: 750 }} cols={3} rowHeight={274}>
                          {rgaImages.map((rgaImage) => (
                            <ImageListItem key={rgaImage.src}>
                              <img
                                srcSet={rgaImage.src}
                                src={rgaImage.src}
                                alt={rgaImage.title}
                                loading="lazy"
                              />
                            </ImageListItem>
                            // <ImageListItem key={rgaImage.src}>
                            //   <img
                            //     srcSet={`${rgaImage.src}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                            //     src={`${rgaImage.src}?w=164&h=164&fit=crop&auto=format`}
                            //     alt={rgaImage.title}
                            //     loading="lazy"
                            //   />
                            // </ImageListItem>
                          ))}
                        </ImageList>
                  </CardContent>
              </Card>
              <Button
                  type="submit"
                  disabled={submitDisabled}
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}>
                  Submit
              </Button>
              <Card>
                  <CardHeader title="Warranty Policy"></CardHeader>
                  <CardContent>
                      <Link href={WarrantyPolicy} target="_blank" download="RCP RGA Warrany _ Return Goods Policy rev 3.pdf">Warranty Policy</Link>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Return Shipping Information"></CardHeader>
                  <CardContent>
                      <Box>
                          <p>
                          Richardson Cooling Packages, LLC
                          <br/> 1900 New Butler Road
                          <br/> New Castle, PA 16101
                          <br/> <br/> UPS Account #: Y97365
                          <br/> R&L Carriers Account #: SRF731
                          </p>
                      </Box>
                  </CardContent>
              </Card>
          </Stack>
          <Snackbar open={openSuccessSnackbar} autoHideDuration={6000} onClose={handleSuccessSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleSuccessSnackbarClose} severity="success" variant="filled" sx={{ width: '100%' }}>
                  Success! Your RGA has been submitted.
              </Alert>
          </Snackbar>
          <Snackbar open={openErrorSnackbar} autoHideDuration={6000} onClose={handleErrorSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleErrorSnackbarClose} severity="error" variant="filled" sx={{ width: '100%' }}>
                  Error, something went wrong with your RGA submission.
              </Alert>
          </Snackbar>
          <Snackbar open={emptyDescriptionSnackbar} autoHideDuration={6000} onClose={handleEmptyDescriptionSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert onClose={handleEmptyDescriptionSnackbarClose} severity="error" variant="filled" sx={{ width: '100%' }}>
                  Error, one or more of your *Description of Failure*'s is empty.
              </Alert>
          </Snackbar>
      </Box>
  );
}

export default RGAForm;